
export const SPACING = {
  'sp-px': 1,
  'sp-2': 2,
  'sp-4': 4,
  'sp-8': 8,
  'sp-12': 12,
  'sp-16': 16,
  'sp-20': 20,
  'sp-24': 24,
  'sp-28': 28,
  'sp-32': 32,
  'sp-40': 40,
  'sp-48': 48,
  'sp-56': 56,
  'sp-64': 64,
  'sp-72': 72,
  'sp-80': 80,
  'sp-96': 96,
  'sp-100': 100,
  'sp-112': 112,
  'sp-126': 126,
  'sp-200': 200,
};

export const BOTTOM_SPACING_SCROLLVIEW = SPACING['sp-126'];

// @react-native-community/slider v5 (bumped from 4.5.2 during the SDK 57 upgrade) only
// draws its own round thumb image when `thumbSize` is set -- see ios/RNCSlider.m
// refreshThumb(), which fills an ellipse of thumbSize x thumbSize. With no thumbSize
// and no thumbImage it sets no image at all and falls back to the system thumb, which
// the native view's frame then stretched into a wide oval. An explicit size restores a
// circle. Harmless on Android (native SeekBar thumb) and on web, which draws its own
// circular thumb from constants.THUMB_SIZE.
export const SLIDER_THUMB_SIZE = 20;
